export const GenericEvent = {
    DlpTooltipBannerCreated: 'DlpTooltipBannerCreated',
    SensitivityErrorBannerCreated: 'SensitivityErrorBannerCreated',
    SensitivityErrorBannerRemoved: 'SensitivityErrorBannerRemoved',
    MandatoryLabelingBannerCreated: 'MandatoryLabelingBannerCreated',
    MandatoryLabelingBannerRemoved: 'MandatoryLabelingBannerRemoved'
};
